import React from "react";
import MenuItem from "./MenuItem";
import { useParams } from "react-router-dom";

interface MenuItemProps {
  Menu: any;
  userData: any;
  name: string;
  activeMenu?: any;
  handleMenuItemClick?: any;
  open?: boolean;
  subMenuOpen?: any;
  setSubMenuOpen?: any;
}

const SideMenu: React.FC<MenuItemProps> = ({
  Menu,
  userData,
  name,
  activeMenu,
  handleMenuItemClick,
  open = false,
  subMenuOpen,
  setSubMenuOpen,
}) => {
  const params = useParams();
  const uid = params?.creditor_uid
    ? params?.creditor_uid
    : localStorage.getItem(`selected_${name}_uid`);

  return (
    <>
      {Menu?.map((Menu: any, index: number) =>
        userData?.panels?.panels?.map(
          (panel: any, indx: number) =>
            panel?.type === `${name}` &&
            (panel?.uid === uid || panel?.type === `admin`) &&
            panel?.menus?.map(
              (menu: any, i: number) =>
                menu?.code_name &&
                (menu?.code_name !== "CREDITOR_SEND_BANK" ||
                  menu?.code_name !== "SETTLEMENT_STORES" ||
                  panel?.name === "بلو بانک") &&
                menu?.code_name === Menu?.code && (
                  <React.Fragment key={`menu-${indx}-${i}-${index}`}>
                    <MenuItem
                      activeMenu={activeMenu}
                      handleMenuItemClick={handleMenuItemClick}
                      open={open}
                      Menu={Menu}
                      title={menu?.name}
                      index={index}
                      subMenuOpen={subMenuOpen}
                      setSubMenuOpen={setSubMenuOpen}
                      haveSub={menu?.sub_menus ? true : false}
                    />
                    {menu?.sub_menus?.map(
                      (subMenu: any, j: number) =>
                        Menu?.subMenus &&
                        subMenuOpen === Menu.src && (
                          <ul key={`submenu-${indx}-${i}-${j}`} className="">
                            {Menu.subMenus.map(
                              (SubMenu: any, k: number) =>
                                subMenu?.code_name === SubMenu?.code && (
                                  <MenuItem
                                    key={`subMenu-item-${indx}-${i}-${j}-${k}`}
                                    activeMenu={activeMenu}
                                    handleMenuItemClick={handleMenuItemClick}
                                    open={open ? open : false}
                                    Menu={SubMenu}
                                    isSub={true}
                                    index={k}
                                    subMenuOpen={subMenuOpen}
                                    setSubMenuOpen={setSubMenuOpen}
                                  />
                                )
                            )}
                          </ul>
                        )
                    )}
                  </React.Fragment>
                )
            )
        )
      )}
    </>
  );
};

export default SideMenu;
